/**
 * index
 *
 * @Author  Yee
 * @DATE    create on 2019/6/26
 * @DESC    工具类
 */
import Cookies from 'js-cookie'
import lrz from 'lrz'

function formatNumber(n) {
    const str = n.toString()
    return str[1] ? str : `0${str}`
}

export function isPhoneNumber(value) {
    if (!value) return false
    return value.match(/^1\d{10}$/)
}

export function isCarNumber(value) {
    if (!value) return false
    let reg = new RegExp(
        '^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-Z0-9]{4}[A-Z0-9挂学警港澳]{1}$'
    )
    return reg.exec(value)
}

/**
 * 是否是移动端
 * @return {boolean}
 */
export function isMobile() {
    let is_mobile =
        navigator.userAgent
            .toLowerCase()
            .match(
                /(ipod|iphone|android|coolpad|mmp|smartphone|midp|wap|xoom|symbian|j2me|blackberry|wince)/i
            ) != null
    return is_mobile
}

/**
 * 是否是微信端
 * @return {boolean}
 */
export function isWeChatEnv() {
    let ua = navigator.userAgent.toLowerCase()
    return !!(
        ua.match(/MicroMessenger/i) &&
        (ua.match(/Android/i) || ua.match(/iPhone/i))
    )
}

/**
 * 是否是支付宝端
 * @return {boolean}
 */
export function isALiEnv() {
    let ua = navigator.userAgent.toLowerCase()
    return !!(
        ua.match(/Alipay/i) &&
        (ua.match(/Android/i) || ua.match(/iPhone/i))
    )
}

/**
 * 是否是微信小程序端
 * @return {boolean}
 */
export function isMiniProgramEnv() {
    return window.__wxjs_environment === 'miniprogram'
}

/**
 * 是否是微信小程序端 异步
 * @return {Promise<unknown>}
 */
export function isWxMiniProgramEnv() {
    return new Promise(resolve => {
        if (isMiniProgramEnv()) {
            resolve(true)
        } else {
            let timer = setTimeout(() => {
                resolve(false)
            }, 3000)
            wx.miniProgram.getEnv(res => {
                clearTimeout(timer)
                resolve(res.miniprogram)
            })
        }
    })
}

export function isAndroid() {
    return window.navigator.userAgent.indexOf('Android') > -1
}

export function isIos() {
    return isIPad() || isIPhone()
}

export function isIPhone() {
    return window.navigator.userAgent.indexOf('iPhone') > -1
}

export function isIPad() {
    return window.navigator.userAgent.indexOf('iPad') > -1
}

export function getUrlParam(name) {
    let after = window.location.hash.split('?')[1]
    let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
    if (after) {
        let r = after.match(reg)
        if (r != null) return decodeURIComponent(r[2])
        return null
    } else {
        let t = window.location.search.substr(1).match(reg)
        if (t != null) return decodeURIComponent(t[2])
        return null
    }
}

export function formatTime(date) {
    const year = date.getFullYear()
    const month = date.getMonth() + 1
    const day = date.getDate()

    const hour = date.getHours()
    const minute = date.getMinutes()
    const second = date.getSeconds()

    const t1 = [year, month, day].map(formatNumber).join('/')
    const t2 = [hour, minute, second].map(formatNumber).join(':')

    return `${t1} ${t2}`
}

export function getSession(key) {
    return window.sessionStorage.getItem(key)
}

export function setSession(key, value) {
    return window.sessionStorage.setItem(key, value)
}

/**
 * 存储到本地
 * @param {*} key
 * @param {*} value
 */
export function setItem(key, value) {
    return localStorage.setItem(key, value)
}

/**
 *
 * 拿取本地的数据
 * @export
 * @param {*} key
 * @returns
 */
export function getItem(key) {
    return localStorage.getItem(key)
}

/**
 *
 * 删除本地的数据
 * @export
 * @param {*} key
 * @returns
 */
export function removeItem(key) {
    return localStorage.removeItem(key)
}

/**
 *
 *
 * @export
 * @returns true是微信浏览器
 */
export function isWeiXin() {
    const ua = window.navigator.userAgent.toLowerCase()
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        return true
    } else {
        return false
    }
}

/**
 *
 *
 * @export
 * @param {*} num 传入的数字
 * @param {*} n 需要字符的长度
 */
export function timePrefixInteger(num, n) {
    return (Array(n).join(0) + num).slice(-n)
}

/**
 *
 * 设置cookie
 * @export
 * @param {*} cname
 *
 */
export function setCookie(key, value) {
    const domain = process.env.NODE_ENV === 'development' ? '' : '.yunlsp.com'
    let a = {}
    document.cookie
        .split(';')
        .map(item => item.trimLeft())
        .forEach(item => {
            const [key, value] = item.split('=')
            if (key && value) {
                a[key] = value
            }
        })
    a[key] = value
    const localSessionId = Cookies.get(key, { domain }) || null
    if (localSessionId) {
        Cookies.remove(key, { domain })
    }
    Cookies.set(key, value, { domain })
    // document.cookie = Object.entries(a).map(([key, value]) => `${key}=${value}`).join('; ') + `;path=/;domain=${domain}`
    // let valueBack = value.indexOf('sso_sessionid') >= 0 ? value.split('=')[1] : value
    // console.log(valueBack, '过滤后的value值')
    // console.log('setCookie', `${key}=${valueBack};path=/;domain=.yunlsp.com`, '124')
    // document.cookie = `${key}=${valueBack};path=/;domain=${domain}`
}

/**
 *
 *
 * @export
 * @param {*} key
 * @param {*} value
 */
export function removeCookie(key) {
    let date = new Date()
    date.setTime(date.getTime() - 1000)
    document.cookie = `${key}=;expires=${date.toUTCString()};path=/;domain=.yunlsp.com`
    console.log(document.cookie, `清楚的cookie=${key}`)
}

/**
 *
 * 删除所有cookie
 * @export
 */
export function clearAllCookie() {
    const keys = document.cookie.match(/[^ =;]+(?==)/g)
    console.log(keys, '本地所有的cookie')
    if (keys) {
        for (var i = keys.length; i--; ) {
            document.cookie = `${keys[i]}=;expires=${new Date(
                0
            ).toUTCString()};path=/;domain=.yunlsp.com`
        }
    }
    console.log(document.cookie, '本地的cookie')
}

export default {
    /**
     * @param 要跳转的地址
     * 微信reLaunch方法
     */
    wxRaLunch: url => {
        wx.miniProgram.reLaunch({
            url
        })
    },
    /**
     * @param url 要跳转的地址
     * 微信RedirectTo方法
     */
    wxRedirectTo: url => {
        wx.miniProgram.redirectTo({
            url
        })
    },
    /**
     * @param url 要跳转的地址
     * 微信NavigateTo方法
     */
    wxNavigateTo: url => {
        wx.miniProgram.navigateTo({
            url
        })
    },
    /**
     * @param delta 回退的层级
     * 微信页面回退
     */
    wxNavigateBack: delta => {
        wx.miniProgram.navigateBack({
            delta
        })
    },
    /**
     * @param url 要跳转的地址
     * 微信switchTab方法
     */
    wxSwitchTab: url => {
        wx.miniProgram.switchTab({
            url
        })
    },
    /**
     * @param fileData 图片文件
     * 压缩图片
     */
    compress: async ({ file }) => {
        const fileresult = await lrz(file, {
            width: 600,
            height: 800,
            quality: 0.9
        })
        return fileresult.file
    },
    /**
     * 转换url参数
    */
    toQueryPair: params => {
        let url = '?'
        for (const key in params) {
            if (params.hasOwnProperty(key)) {
                const element = params[key]
                url += `${key}=${element}&`
            }
        }
        return url
    }
}
